
import styled from 'styled-components'

const FormGroup = styled.div`
    display: block;
    width: 100%;
    margin-bottom: 16px;
`;

export default FormGroup;